'use client';
import Header from '@/app/components/Header';
import { AllowedWidths } from '@/app/components/Slideover';
import { PropertyPageSlideoverContext } from '@/app/context/PropertyPageSlideover.context';
import { useState } from 'react';

function SlideoutContextProvider({ children }) {
  const [needsConfirmation, setNeedsConfirmation] = useState(false);
  const [slideOpen, setSlideOpen] = useState(false);
  const [slideTitle, setSlideTitle] = useState('');
  const [slideContent, setSlideContent] = useState<React.ReactNode>(null);
  const [slideWidth, setSlideWidth] = useState<AllowedWidths>('standard');

  return (
    <PropertyPageSlideoverContext.Provider
      value={{
        needsConfirmation,
        setNeedsConfirmation,
        slideOpen,
        setSlideOpen,
        slideTitle,
        setSlideTitle,
        slideContent,
        setSlideContent,
        slideWidth,
        setSlideWidth,
      }}
    >
      {children}
    </PropertyPageSlideoverContext.Provider>
  );
}

export default function DashboardLayout({ children }: { children: React.ReactNode }) {
  return (
    <>
      <Header title="Fiona Posts" />
      <SlideoutContextProvider>{children}</SlideoutContextProvider>
    </>
  );
}
